module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexRow"
  }, [(_vm.displaySummary) ? _c('div', {
    staticClass: "currentSummary"
  }, [_vm._v("\n    " + _vm._s(_vm.numCompleted) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('block-row', {
    attrs: {
      "blocks": _vm.blocks,
      "category": _vm.category,
      "color": _vm.color,
      "categoryId": _vm.categoryId,
      "quota": _vm.quota,
      "isContinuous": _vm.isContinuous,
      "customDate": _vm.customDate
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44d21e0f!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CurrentBlocks.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-44d21e0f!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/components/CurrentBlocks.vue
// module chunks = 0